export enum FundraisingLanguages {
  en = 'en',
  fr = 'fr',
  es = 'es',
  he = 'he',
  y = 'y',
}
